import { render, staticRenderFns } from "./returnOrderInfo.vue?vue&type=template&id=f8e53aa8&scoped=true&"
import script from "./returnOrderInfo.vue?vue&type=script&lang=js&"
export * from "./returnOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./returnOrderInfo.vue?vue&type=style&index=0&id=f8e53aa8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8e53aa8",
  null
  
)

export default component.exports